module.exports = __webpack_public_path__ + "media/components/country-flag/static/at-251c9db5c487a012ea542441b930aa1a.svg";